const sandboxSize = 500 * 1024 * 1024 // sandbox size is 500
const identificationFilePath = 'UUID' + '/' + 'WEB-UUID' // uuid save to this file.
class SandboxManager {
  async getUUIDFromSandbox () {
    window.requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem
    return new Promise(async (resolve, reject) => {
      // if usedSize is 0, sanbox is unavailabel.
      let usedSize = await getSandBoxUsedSize()
      console.log('usedSize', usedSize)
      if (usedSize === 0) {
        reject()
      }
      window.requestFileSystem(window.PERSISTENT, sandboxSize, (fs) => {
        fs.root.getFile(identificationFilePath, {
          create: false
        }, function (fileEntry) {
          fileEntry.file(function readFile (file) {
            var reader = new FileReader()
            reader.onloadend = function (e) {
              resolve(e.target.result)
            }
            reader.readAsText(file)
          }, (error) => {
            reject(error)
          })
        }, (error) => {
          reject(error)
        })
      })
    })
  }
}

function getSandBoxUsedSize () {
  return new Promise((resolve, reject) => {
    if (!navigator.webkitPersistentStorage) {
      resolve(0)
    }
    navigator.webkitPersistentStorage.queryUsageAndQuota(
      function (usedBytes, grantedBytes) {
        // console.log('总容量：%sM, 已使用容量：%sM, 剩余容量：%sM', grantedBytes/(1024*1024), usedBytes/(1024*1024), (grantedBytes - usedBytes)/(1024*1024))
        resolve(usedBytes)
      })
  })
}
export default new SandboxManager()



// WEBPACK FOOTER //
// ./src/new-login-2018/common/Sandbox.js